module.exports = __webpack_public_path__ + "h5/img/index2-0.16d2a54d.png";